<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="workSpaceTab">
    <div class="contenedorPag">
      <app-contenedor-elementos class="contenedorNotificaciones">
        <div body class="contenedorNotificacionesInt">
          <div class="notificacionesPos">
            <div class="w3-titulo-contenidomenuSC">
              <span class="w3-margin-left-contenido w3-tituloZonas">
                {{'gestion.admin.catalogos.notiGenerales'|translate}}
              </span>
            </div>
            <div class="w3-row" style="margin-left: 1vw;">
              @if (loadingInfo) {
              <div style="display: flex; justify-content: center;">
                <ngx-skeleton-loader count="3" [theme]="{
                                      'border-radius': '10px',
                                      height: '3vh',
                                      width: '12vw',
                                      margin: '1vh 5vw 1vh 1vw'
                                      
                                  }" />
              </div>
              } @else {
              @for (tem of templatesGenerales; track tem.id) {
              <div class="contenedorTem textoOverFlow">
                <mat-slide-toggle color="orange" [checked]="tem.check" (change)="cambioCheckBox(tem)">
                  <span class="textoTem" matTooltip="{{tem.name}}">{{tem.name}}</span>
                </mat-slide-toggle>
              </div>
              }
              }
            </div>
            @if (siVeActas) {
            <div class="w3-row  w3-titulo-contenidomenuSC">
              <span class="w3-margin-left-contenido w3-tituloZonas">
                {{'gestion.admin.catalogos.notiActas'|translate}}
              </span>
            </div>
            }
            @if (siVeActas) {
            <div class="w3-row" style="margin-left: 1vw;">
              @if (loadingInfo) {
              <div style="display: flex; justify-content: center ;">
                <ngx-skeleton-loader count="3" [theme]="{
                                      'border-radius': '10px',
                                      height: '3vh',
                                      width: '12vw',
                                      margin: '1vh 5vw 1vh 1vw'                                
                                  }" />
              </div>
              } @else {
              @for (tem of templatesActas; track tem.id) {
              <div class="contenedorTem textoOverFlow">
                <mat-slide-toggle color="orange" [checked]="tem.check" (change)="cambioCheckBox(tem)">
                  <span class="textoTem" matTooltip="{{tem.name}}">{{tem.name}}</span>
                </mat-slide-toggle>
              </div>
              }
              }
            </div>
            }
            <div class="w3-row">
              @if (realizoCambios) {
              <div class="w3-right" style="margin-top: 1vh;">
                <div class="botonesGuardado">
                  <button mat-flat-button color="success" (click)="guardarSeleccion()">
                    {{'gestion.admin.catalogos.guardar'|translate}}
                  </button>
                </div>
                <div class="botonesGuardado">
                  <button mat-stroked-button color="success2" (click)="cancelarSeleccion()" type="reset">
                    {{'gestion.admin.catalogos.cancelar'|translate}}
                  </button>
                </div>
              </div>
              }
            </div>
          </div>
          <div class="w3-rest iconoInfo" style="margin-right: 2vw;">
            <mat-icon class="w3-zindex w3-button w3-dropdown-click" (click)="modalInfo()"
              [ngStyle]="{'color':'gray'}">info_outline</mat-icon>
          </div>
        </div>
      </app-contenedor-elementos>
      <ng-container>
        <app-contenedor-elementos class="contenedorCargaImagen" [header]="{
          title: 'gestion.admin.catalogos.logotipo'|translate
        }">
          <div body class="w3-row informacionLogOut">
            @if(loadingInfo) {
            <div style="display: flex; justify-content: center; align-items: center;">
              <ngx-skeleton-loader count="1" [theme]="{
                'border-radius': '10px',
                height: '18vh',
                width: '12vw',
              }" />
            </div>
            }
            @else {
            <ng-container>
              <div class="containerImage">
                @if (bufferArray.length !== 0) {
                  <br>
                  <img src="{{urll}}" width="100% border" (click)="vizualizarImagen()" style="cursor: pointer;">
                }
                @if (bufferArray.length === 0) {
                  <span class="w3-margin-left-contenido w3-subtitulo">
                    <br>
                    <br>
                    {{'gestion.admin.catalogos.noLogotipo'|translate}}
                  </span>
                }
              </div>
            </ng-container>
            }
          </div>
        </app-contenedor-elementos>
      </ng-container>
      <app-contenedor-elementos class="contenedorTabla" [header]="{
        title: 'gestion.admin.catalogos.tablaResponsables'|translate
      }">
        <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        <div class="botones">
          <div class="w3-rest" style="margin-top: 1vh; margin-right: 1vw;">
            <button (click)="abrirAgregarRes()"
              matTooltip="{{'gestion.admin.catalogos.agregarResponsable'|translate}}" class="colorBotonDeNuevo">
              <mat-icon class="iconoMen">add_circle_outline</mat-icon>
              {{'gestion.admin.catalogos.agregarResponsable'|translate}}
            </button>
          </div>
        </div>
        <mat-menu #menu2="matMenu">
          <button (click)="exportarExcel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'gestion.admin.catalogos.exportarXlsx'|translate}}</span>
          </button>
        </mat-menu>

        <div body class="w3-row tablaPos">
          @if (!mostabla) {
          <app-skeleton-table [columnas]="5" [filas]="6" />
          } @else {
          <table class="tabla-aleema">
            <thead>
              <tr>
                <th>
                  {{'gestion.admin.catalogos.puesto'|translate}}
                </th>
                <th>
                  {{'gestion.admin.catalogos.nombre'|translate}}
                </th>
                <th>
                  {{'gestion.admin.catalogos.correo'|translate}}
                </th>
                <th>
                  {{'gestion.admin.catalogos.acciones'|translate}}
                </th>
                @if (siVeActas) {
                <th>
                  {{'gestion.admin.catalogos.validadorActas'|translate}}
                </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (element of responsables; track element.id) {
              <tr>
                <td class="textoOverFlow" [matTooltip]="element.name" [appOverflowTooltip]="element.name">
                  {{element.name}}
                </td>
                <td class="anchosColumnas textoOverFlow" [matTooltip]="obtResponsable(element.responsibles[0])"
                [appOverflowTooltip]="obtResponsable(element.responsibles[0])">
                  {{obtResponsable(element.responsibles[0])}}
                </td>
                <td class="anchosColumnas textoOverFlow" [matTooltip]="obtCorreo(element.responsibles[0])"
                [appOverflowTooltip]="obtCorreo(element.responsibles[0])">
                  {{obtCorreo(element.responsibles[0])}}
                </td>
                <td class="w3-center">
                  <mat-icon class="iconoMen" (click)="abrirEditarRes(element.responsibles[0], element.id)"
                    matTooltipPosition="left"
                    matTooltip="{{'gestion.admin.catalogos.editar'|translate}}">edit</mat-icon>
                  <mat-icon class="iconoMen" (click)="eliminarResponsable(element.responsibles[0], element)"
                    matTooltipPosition="right"
                    matTooltip="{{'gestion.admin.catalogos.eliminar'|translate}}">delete</mat-icon>
                </td>
                @if (siVeActas) {
                <td class="w3-center">
                  <mat-checkbox (change)="cambioValidator(element.responsibles[0])"
                    [checked]="element.responsibles[0].isValidator">
                  </mat-checkbox>
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
          }
        </div>
      </app-contenedor-elementos>
      <ng-container *appRoles="permisos.ADMINISTRACION">
        <app-contenedor-elementos class="contenedorLogOut" [header]="{
          title: 'gestion.admin.catalogos.expiracionSesion'|translate
        }">
          <div body class="w3-row informacionLogOut">
            <div class="w3-row" style="font-weight: 500; margin-bottom: 1vh;">
              {{'gestion.admin.catalogos.cierreSesionAuto'|translate}}
            </div>
            <mat-slide-toggle color="orange" [checked]="logOutAct" (change)="logOutAct=!logOutAct">
              @if (logOutAct) {
              <span class="textoTem">{{'gestion.admin.catalogos.desactivar'|translate}}</span>
              } @else {
              <span class="textoTem">{{'gestion.admin.catalogos.activar'|translate}}</span>
              }
            </mat-slide-toggle>

            <div class="w3-row" style="margin-top: 3vh;" [ngClass]="logOutAct?'':'w3-disabled'">
              <div class="w3-row" style="font-weight: 500; margin-bottom: 2vh;">
                {{'gestion.admin.catalogos.tiempoInactividad'|translate}}
              </div>
              <mat-slider class="example-margin" [max]="20" [min]="5" [step]="5" [showTickMarks]="true">
                <input matSliderThumb [(ngModel)]="logOutTime" name="logOutTime" aria-labelledby="example-name-label">
              </mat-slider>

              <span style="font-weight: 500; margin-left: 1vw;">
                {{logOutTime}} {{'gestion.admin.catalogos.minutos'|translate}}
              </span>
            </div>

            @if (realizoCambiosLogOut()) {
            <div class="w3-right" style="margin-top: 3vh; margin-bottom: 2vh;">
              <div class="botonesGuardado">
                <button mat-flat-button color="success" (click)="guardarCambiosLogOut()">
                  {{'gestion.admin.catalogos.guardar'|translate}}
                </button>
              </div>
              <div class="botonesGuardado">
                <button mat-stroked-button color="success2" type="reset" (click)="cancelarCambiosLogOut()">
                  {{'gestion.admin.catalogos.cancelar'|translate}}
                </button>
              </div>
            </div>
            }
          </div>
        </app-contenedor-elementos>
      </ng-container>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="agrgearRes" (close)="cerrarFormulario()">
  <div modal-header>
    {{'gestion.admin.catalogos.nuevoResponsable'|translate}}
  </div>

  <div modal-body>
    <form [formGroup]="formNuevo">

      <div class="form-group">
        <label for="nombre" class="form-label">
          {{'gestion.admin.catalogos.nombre'|translate}} <span>*</span>
        </label>
        <input id="nombre" formControlName="nombre" type="text" class="form-input anchosInputs"
          placeholder="{{'gestion.admin.catalogos.ingresarNombre'|translate}}" required>
      </div>

      <div class="form-group">
        <label for="primerApellido" class="form-label">
          {{'gestion.admin.catalogos.apellidos'|translate}} <span>*</span>
        </label>
        <input id="primerApellido" formControlName="primerApellido" type="text" class="form-input anchosInputsShort"
          placeholder="{{'gestion.admin.catalogos.primerApellido'|translate}}" required>
        <input id="segundoApellido" formControlName="segundoApellido" type="text" class="form-input anchosInputsShort"
          placeholder="{{'gestion.admin.catalogos.segundoApellido'|translate}}">
      </div>

      <div class="form-group">
        <label for="correo" class="form-label">
          {{'gestion.admin.catalogos.correo'|translate}} <span>*</span>
        </label>
        <input id="correo" formControlName="correo" type="email" class="form-input anchosInputs"
          placeholder="{{'gestion.admin.catalogos.ingresarCorreo'|translate}}" required>
      </div>

      <div class="form-group">
        <label for="puestoCargo" class="form-label">
          {{'gestion.admin.catalogos.puesto'|translate}} <span>*</span>
        </label>
        <input id="puestoCargo" formControlName="puestoCargo" type="text" class="form-input anchosInputs"
          placeholder="{{'gestion.admin.catalogos.ingresarPuesto'|translate}}" required>
      </div>

    </form>
  </div>

  <div modal-footer>
    <div class="w3-right" style="margin-top: 2vh;">
      <div class="botonesModales" [ngClass]="puedeGuardarAgregar()">
        <button mat-flat-button color="success" (click)="alertasGuardado('nuevo')" style="height: 4vh;">
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="cerrarFormulario()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="editarRes" (close)="cerrarFormulario()">
  <div modal-header>
    {{'gestion.admin.catalogos.edicionResponsable'|translate}}
  </div>

  <div modal-body>
    <form [formGroup]="formEditar" (ngSubmit)="alertasGuardado('editar')">

      <div class="form-group">
        <label for="nombreEditar" class="form-label">
          {{'gestion.admin.catalogos.nombre'|translate}} <span>*</span>
        </label>
        <input id="nombreEditar" formControlName="nombre" type="text" class="form-input anchosInputs"
          placeholder="{{'gestion.admin.catalogos.ingresarNombre'|translate}}" required>
      </div>

      <div class="form-group">
        <label for="primerApellidoEditar" class="form-label">
          {{'gestion.admin.catalogos.apellidos'|translate}} <span>*</span>
        </label>
        <input id="primerApellidoEditar" formControlName="primerApellido" type="text"
          class="form-input anchosInputsShort" placeholder="{{'gestion.admin.catalogos.primerApellido'|translate}}"
          required>
        <input id="segundoApellidoEditar" formControlName="segundoApellido" type="text"
          class="form-input anchosInputsShort" placeholder="{{'gestion.admin.catalogos.segundoApellido'|translate}}">
      </div>

      <div class="form-group">
        <label for="correoEditar" class="form-label">
          {{'gestion.admin.catalogos.correo'|translate}} <span>*</span>
        </label>
        <input id="correoEditar" formControlName="correo" type="email" class="form-input anchosInputs"
          placeholder="{{'gestion.admin.catalogos.ingresarCorreo'|translate}}" required>
      </div>

      <div class="form-group">
        <label for="puestoCargoEditar" class="form-label">
          {{'gestion.admin.catalogos.puesto'|translate}} <span>*</span>
        </label>
        <input id="puestoCargoEditar" formControlName="puestoCargo" type="text" class="form-input anchosInputs"
          placeholder="{{'gestion.admin.catalogos.ingresarPuesto'|translate}}" required>
      </div>
    </form>
  </div>

  <div modal-footer>
    <div class="w3-right" style="margin-top: 2vh;">
      <div class="botonesModales" [ngClass]="puedeGuardarEditar()">
        <button mat-flat-button color="success" (click)="alertasGuardado('editar')" style="height: 4vh;">
          {{ 'menu.Guardar' | translate }}
        </button>
      </div>
      <div class="botonesModales">
        <button mat-stroked-button color="success2" (click)="cerrarFormulario()" style="height: 4vh;">
          {{ 'menu.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>